import { downgradeComponent } from '@angular/upgrade/static';
import angular from 'angular';
import { ProductDetailsFormComponent } from './product-details-form.component';

// TODO - remove when paymentPanel STAB-908 (DEV-18469)
export const ngxProductDetailsFormModule = angular.module('ngxProductDetailsFormModule', [])
	.directive('ngxProductDetailsForm', downgradeComponent({ component: ProductDetailsFormComponent }))
	.name;
